import { CalendarDisplayData } from 'components/mrp/stores/calendarStore/calendarStore.types';
import {
  AppointmentFormFieldData,
  AppointmentFormFieldEntity
} from 'components/mrp/components/AppointmentForm/AppointmentForm.types';
import dayjs from 'dayjs';

export const createAppointment = ({
  start,
  calendar,
  durationInMinutes
}: {
  start?: dayjs.Dayjs;
  calendar?: CalendarDisplayData;
  durationInMinutes: number;
}): AppointmentFormFieldData | undefined => {
  if (!start || !calendar) return;

  const planningEntities = calendar.sources.map(
    (src) =>
      ({
        label: src.label,
        ...src.planningEntityIdentifier
      }) as AppointmentFormFieldEntity
  );

  const formData: AppointmentFormFieldData = {
    start: start.toISOString(),
    end: start.add(durationInMinutes, 'minutes').toISOString(),
    planEntities: {
      CLIENT: planningEntities.filter(
        (pEi) => pEi.planningEntityType == 'CLIENT'
      ),
      EMPLOYEE: planningEntities.filter(
        (pEi) => pEi.planningEntityType == 'EMPLOYEE'
      ),
      WORKPLACE: planningEntities.filter(
        (pEi) => pEi.planningEntityType == 'WORKPLACE'
      ),
      RESOURCE: planningEntities.filter(
        (pEi) => pEi.planningEntityType == 'RESOURCE'
      )
    }
  };

  return formData;
};
